var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8281 11.25C48.6445 12.2742 52.1244 14.2843 54.9185 17.0784C57.7126 19.8725 59.7226 23.3523 60.7469 27.1687",
    stroke: "#132238",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4922 19.9404C44.7875 20.55 46.8809 21.7556 48.5602 23.4349C50.2395 25.1142 51.4451 27.2076 52.0547 29.5029",
    stroke: "#132238",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0156 35.1003C28.3309 39.8816 32.1972 43.7379 36.9844 46.041C37.3375 46.2082 37.7281 46.2805 38.1177 46.2509C38.5073 46.2214 38.8824 46.0908 39.2062 45.8722L46.2375 41.1753C46.5481 40.9646 46.9071 40.8361 47.2809 40.8016C47.6547 40.7672 48.0311 40.8281 48.375 40.9785L61.5375 46.6316C61.9874 46.8188 62.3632 47.1487 62.6071 47.5706C62.8511 47.9924 62.9496 48.4827 62.8875 48.966C62.4703 52.2221 60.881 55.2147 58.4169 57.3837C55.9528 59.5527 52.7828 60.7496 49.5 60.7503C39.3555 60.7503 29.6264 56.7204 22.4532 49.5472C15.2799 42.3739 11.25 32.6449 11.25 22.5003C11.2507 19.2176 12.4476 16.0476 14.6166 13.5835C16.7857 11.1194 19.7782 9.53002 23.0344 9.11284C23.5177 9.05076 24.008 9.14927 24.4298 9.39321C24.8516 9.63714 25.1815 10.013 25.3687 10.4628L31.0219 23.6535C31.1689 23.9919 31.2304 24.3614 31.201 24.7292C31.1715 25.0971 31.0521 25.452 30.8531 25.7628L26.1562 32.9066C25.9471 33.2297 25.8244 33.601 25.7998 33.9851C25.7752 34.3692 25.8495 34.7532 26.0156 35.1003V35.1003Z",
    stroke: "#132238",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/PhoneCall.95d1b950c725fd54b513b7733ee2d492.svg";
export { ForwardRef as ReactComponent };